import type { RunSummary } from "./types";

export type LeaderboardMetric = "score" | "round" | "flow";
export type LeaderboardPeriod = "daily" | "monthly" | "all-time";

export const DEFAULT_LEADERBOARD_METRIC: LeaderboardMetric = "score";
export const DEFAULT_LEADERBOARD_PERIOD: LeaderboardPeriod = "daily";
export const LEADERBOARD_LIMIT = 10;

export const LEADERBOARD_METRIC_OPTIONS: ReadonlyArray<{
  value: LeaderboardMetric;
  label: string;
}> = [
  { value: "score", label: "SCORE" },
  { value: "round", label: "ROUND" },
  { value: "flow", label: "FLOW" }
];

export const LEADERBOARD_PERIOD_OPTIONS: ReadonlyArray<{
  value: LeaderboardPeriod;
  label: string;
}> = [
  { value: "daily", label: "DAILY" },
  { value: "monthly", label: "MONTHLY" },
  { value: "all-time", label: "ALL TIME" }
];

export function getLeaderboardMetricLabel(metric: LeaderboardMetric): string {
  return LEADERBOARD_METRIC_OPTIONS.find((option) => option.value === metric)?.label ?? "SCORE";
}

export function getRunSummaryMetricValue(summary: RunSummary, metric: LeaderboardMetric): number {
  if (metric === "score") {
    return summary.score.value;
  }

  if (metric === "round") {
    return summary.round.value;
  }

  return summary.maxFlow.value;
}

export function getLeaderboardWindowStart(
  period: LeaderboardPeriod,
  now = new Date()
): string | null {
  if (period === "all-time") {
    return null;
  }

  // Use UTC windows so global rankings are consistent for every viewer.
  if (period === "daily") {
    return new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()))
      .toISOString();
  }

  return new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), 1)).toISOString();
}
